import type { Profile } from "~/modules/user/models/Profile.interface";

/**
 * Get the profile label
 * @param profile
 * TODO When we will refactor UserAccount, we will have to remove the translate and translateCheck parameters. In this context,
 *   update the current user triggers the following error: "Uncaught (in promise) SyntaxError: Must be called at the top of a `setup` function"
 * @param translate translation function
 * @param translateCheck function that verify if the translation exists
 */
export function getProfileLabel(
  profile?: Profile,
  translate?: (key: string) => string,
  translateCheck?: (key: string) => boolean,
): string {
  if (profile) {
    if (!translate || !translateCheck) {
      const { t, te } = useI18n();
      translate = t;
      translateCheck = te;
    }

    const key = `profile.label.${profile.name}`;

    return translateCheck(key) ? translate(key) : key;
  } else {
    return "";
  }
}
